// extracted by mini-css-extract-plugin
module.exports = {"adminImageContainer":"AdminImage_adminImageContainer__2WX61","adminImageSubHeader":"AdminImage_adminImageSubHeader__1diyb"};